import React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { useModal } from "@editor/hooks/useModal";
import { trpc } from "@editor/utils/trpc";

import { skipToken } from "@tanstack/react-query";

function CreateFunnel() {
  const projectId = useCurrentProjectId();
  const modal = useModal();

  const { data: funnelTemplates } = trpc.funnelTemplate.list.useQuery(
    projectId ? { projectId } : skipToken,
  );

  return (
    <div className="flex flex-col w-full bg-surface rounded-lg p-5 border border-border relative">
      <div className="text-lg font-medium mb-5">Start a new funnel</div>
      <div className="flex flex-row gap-2">
        <div
          className="flex flex-col border border-border rounded-lg p-3 bg-white cursor-pointer hover:bg-sheet"
          onClick={() => {
            modal.openModal({
              type: "createFunnelModal",
              props: { projectId: projectId ?? "" },
            });
          }}
        >
          <div className="text-base font-medium">Blank Funnel</div>
          <div className="text-sm text-muted">Start from scratch</div>
        </div>
        {funnelTemplates?.map((funnelTemplate) => (
          <div
            key={funnelTemplate.id}
            className="flex flex-col border border-border rounded-lg p-3 bg-white cursor-pointer hover:bg-sheet"
            onClick={() => {
              modal.openModal({
                type: "createFunnelModal",
                props: {
                  projectId: projectId ?? "",
                  funnelTemplateId: funnelTemplate.id,
                },
              });
            }}
          >
            <div className="text-base font-medium">{funnelTemplate.name}</div>
            <div className="flex flex-col gap-2 mt-2">
              <div className="text-sm font-medium">Funnel Pages:</div>
              <div className="text-sm text-muted flex flex-col gap-1">
                {funnelTemplate.funnelTemplateSteps.map((step) => (
                  <div key={step.id} className="text-sm text-muted">
                    {step.fileTemplate.name}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CreateFunnel;
